import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HubComponent } from '../hub/hub.component';
import { PeticionesComponent } from './peticiones.component';
import { DetallePeticionComponent } from './detalle_peticion/detalle_peticion.component';

export const SUBROUTES: Routes = [
  { path: '', component: PeticionesComponent, children: [] },
  { path: 'detalle', component: DetallePeticionComponent, children: []},
  { path: 'detalle/:peticion', component: DetallePeticionComponent, children: [] }
];

@NgModule({
  imports: [RouterModule.forChild(SUBROUTES)],
  exports: [RouterModule]
})

export class PeticionesRoutingModule { }
